/**
 * Frozen roll algorithm for challenge version 1.1.2.
 *
 * DO NOT EDIT once this version is live on-chain.
 * To change roll behavior, copy this file forward to the next version and edit only that copy.
 *
 * Compare with the previous version:
 *   diff -u www/packages/react-app/src/utils/rollers/<prev>.mjs www/packages/react-app/src/utils/rollers/v1_1_2.mjs
 */
import { getRandomItem, getRandomItemWeighted, seedRandomItem } from '../rollRng.mjs';

export const VERSION = '1.1.2';

/**
 * @param {string} seed block.hash
 * @param {object} challengeConfigVersion
 * @returns {{ version: string, mission: object, loadout: object, success: object }}
 */
export function roll(seed, challengeConfigVersion) {
  seedRandomItem(seed);
  const version = VERSION;

const selectedEnemy = getRandomItem(challengeConfigVersion.enemy);
const selectedDifficulty = getRandomItem(challengeConfigVersion.difficulty);
const selectedDuration = getRandomItem(challengeConfigVersion.duration);
const selectedTeamplay = getRandomItemWeighted(challengeConfigVersion.teamplay, challengeConfigVersion.teamplayWeights);

let selectedStars = getRandomItem(challengeConfigVersion.stars);
while (!isValidStars(selectedDifficulty, selectedStars)) {
  selectedStars = getRandomItem(challengeConfigVersion.stars);
}

const selectedPrimary = getRandomItem(challengeConfigVersion.primary);
const selectedSecondary = getRandomItem(challengeConfigVersion.secondary);
const selectedGrenade = getRandomItem(challengeConfigVersion.grenade);

let selectedStratagem1 = getRandomItem(challengeConfigVersion.SupportWeaponStratagems);
let selectedStratagem2 = getRandomItem(challengeConfigVersion.stratagem);
while (!isValidStratagem([selectedStratagem1], selectedStratagem2, challengeConfigVersion, selectedEnemy)) {
  selectedStratagem2 = getRandomItem(challengeConfigVersion.stratagem);
}

let selectedStratagem3 = getRandomItem(challengeConfigVersion.stratagem);
while (!isValidStratagem([selectedStratagem1, selectedStratagem2], selectedStratagem3, challengeConfigVersion, selectedEnemy)) {
  selectedStratagem3 = getRandomItem(challengeConfigVersion.stratagem);
}

let selectedStratagem4 = getRandomItem(challengeConfigVersion.stratagem);
while (!isValidStratagem([selectedStratagem1, selectedStratagem2, selectedStratagem3], selectedStratagem4, challengeConfigVersion, selectedEnemy)) {
  selectedStratagem4 = getRandomItem(challengeConfigVersion.stratagem);
}

return {
  version,
  mission: {
    enemy: selectedEnemy,
    difficulty: selectedDifficulty,
    duration: selectedDuration,
    teamplay: selectedTeamplay,
    stars: selectedStars,
  },
  loadout: {
    primary: selectedPrimary,
    secondary: selectedSecondary,
    grenade: selectedGrenade,
    stratagem1: selectedStratagem1,
    stratagem2: selectedStratagem2,
    stratagem3: selectedStratagem3,
    stratagem4: selectedStratagem4,
  },
  success: {
    stars: selectedStars,
  },
};
}

function isValidStratagem(selected, strat, config, selectedEnemy) {
  for (let i = 0; i < selected.length; i++) {
    if ((config.BackpackStratagems.includes(selected[i]) && config.BackpackStratagems.includes(strat)) ||
        (config.SupportWeaponStratagems.includes(selected[i]) && config.SupportWeaponStratagems.includes(strat)) ||
        ((config.VehicleStratagems || config.MechStratagems) && (config.VehicleStratagems || config.MechStratagems).includes(selected[i]) && (config.VehicleStratagems || config.MechStratagems).includes(strat)) ||
        selected[i] === strat) {
      return false;
    }
  }

  if ((selectedEnemy === "Terminid" && strat === "SH-20 Balistic Shield Backpack") ||
      (selectedEnemy === "Terminid" && strat === "FX-12 Shield Generator Relay")) {
    return false;
  }

  return true;
}

function isValidStars(difficulty, stars) {
  if ((difficulty === "4 - Challenging or greater" && stars === "4 stars or more") ||
      (difficulty === "4 - Challenging or greater" && stars === "5 stars") ||
      (difficulty === "5 - Hard or greater"        && stars === "5 stars") ||
      (difficulty === "6 - Extreme or greater"     && stars === "5 stars")) {
    return false;
  }

  return true;
}
